export const SportIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1038_31166)">
        <path
          d="M8.00001 1.33334C11.682 1.33334 14.6667 4.31801 14.6667 8.00001C14.6667 11.682 11.682 14.6667 8.00001 14.6667C4.31801 14.6667 1.33334 11.682 1.33334 8.00001C1.33334 4.31801 4.31801 1.33334 8.00001 1.33334ZM9.11334 10.6667H6.88668L5.96668 11.9313L6.33601 13.0687C6.87313 13.2446 7.43482 13.3339 8.00001 13.3333C8.58068 13.3333 9.14001 13.24 9.66401 13.0687L10.0327 11.9313L9.11268 10.6667H9.11334ZM3.52934 7.24801L2.66801 7.87268L2.66668 8.00001C2.66668 9.15334 3.03268 10.2207 3.65468 11.0933H4.92801L5.81001 9.88001L5.12468 7.76668L3.52934 7.24801ZM12.4707 7.24801L10.8753 7.76668L10.19 9.88001L11.0713 11.0933H12.3447C12.9892 10.1908 13.335 9.10907 13.3333 8.00001L13.3313 7.87268L12.4707 7.24801ZM9.52668 2.88868L8.66668 3.51534V5.19334L10.4627 6.49801L11.9553 6.01334L12.3247 4.87801C11.6364 3.92526 10.6532 3.22604 9.52734 2.88868H9.52668ZM6.47201 2.88868C5.34604 3.22622 4.36281 3.92568 3.67468 4.87868L4.04401 6.01334L5.53668 6.49801L7.33334 5.19334V3.51534L6.47268 2.88868H6.47201Z"
          fill="#3643BA"
        />
      </g>
      <defs>
        <clipPath id="clip0_1038_31166">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
